export const devLogger = (prefix, text = '') => {
  // eslint-disable-next-line no-console
  console.log(prefix, text);
};
